<div ngbDropdown container="body" placement="bottom-right">
  <button id="site-provider-action-menu-{{providerId}}"
          class="action-menu-toggle"
          (click)="$event.stopPropagation();"
          ngbDropdownToggle>
    <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
  </button>

  <!--attr. prefix is required: aria-labelledby is not a DOM property, so a plain interpolated
      attribute makes Angular look for one and fail with NG0303.-->
  <div ngbDropdownMenu attr.aria-labelledby="site-provider-action-menu-{{providerId}}">

    <button ngbDropdownItem
            *ngxPermissionsOnly="'settings.update'"
            (click)="onEdit.emit(); $event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="edit" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Edit</span>
      </div>
    </button>

    <button ngbDropdownItem
            *ngxPermissionsOnly="'settings.delete'"
            (click)="onArchive.emit(); $event.stopPropagation();">
      <div class="layout-row layout-align-start-center">
        <bringoz-icon iconName="archive" [classSize]="'xl'" class="margin-right-5 gray-102"></bringoz-icon>
        <span translate>Archive</span>
      </div>
    </button>

  </div>
</div>
